import type { JSX } from "react";
import type { McpDealSearchData } from "./mcpAudit";
import McpQueriesBlock from "./McpQueriesBlock";

/**
 * Structured rendering of what the deals-search MCP server sent back for one
 * call: result counts and the queries it ran.
 *
 * The output row is counts-only by design — which deals came back, and the
 * per-deal relevance verdict behind each one, live on the action row's fan-out
 * detail and its LLM requests, both of which the turn detail already renders.
 */
export default function McpDealSearchOutput({ data }: { data: McpDealSearchData }): JSX.Element {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-4 text-sm text-gray-700">
        <span>
          <span className="font-medium">{data.dealCount ?? 0}</span> deals
        </span>
        <span>
          <span className="font-medium">{data.documentCount ?? 0}</span> documents
        </span>
      </div>
      <McpQueriesBlock goal={data.goal} queries={data.queries} />
    </div>
  );
}
